import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('we_are_populating_the_organisation_with_demo_data'),
    description: defineMessage('when_its_done_youll_be___decision_required_page'),
    warning: defineMessage('do_not_close_this_brows_task_has_been_completed'),
    pullCatalogs: defineMessage('pulling_xero_catalogues'),
    creatingWorkflows: defineMessage('creating_approval_workflows'),
    creatingRequests: defineMessage('creating_bills_and_purchase_orders'),
};
